import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.BRANCH = function (state, payload) {
  state.branch = payload
}
mutations.COURSE = function (state, payload) {
  state.course = payload
}
mutations.LEVEL = function (state, payload) {
  state.level = payload
}
mutations.STUDENT = function (state, payload) {
  state.student = payload
}
mutations.MAIL = function (state, payload) {
  state.mail = payload
}
mutations.INS = function (state, payload) {
  state.instructors = payload
}

const state = {
  rows: [],
  row: null,
  branch: [],
  course: [],
  level: [],
  condition: {},
  student: [],
  mail: [],
  instructors: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data:
      {
        branch: { api: 'M0101BranchService.findBranchForListBox' },
        course: { api: 'M0501CourseService.findCourseForListBox' },
        level: { api: 'M0502CourseLevelService.findAllLevel' },
        ins: { api: 'M0601InstructorService.getInstructorsForSelectBox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('BRANCH', data.branch.output)
        commit('COURSE', data.course.output)
        commit('LEVEL', data.level.output)
        commit('INS', data.ins.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0401Class cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0401Class search')
    return client.postData({ data: { search: { api: 'M0401ClassService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo('No class found')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchStudent: ({ commit, state }, condition) => {
    console.debug('called M0401Class search')
    return client.postData({ data: { student: { api: 'M0602StudentService.findDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.student.output)) {
          SysUtils.showInfo('No student found')
        }
        commit('STUDENT', data.student.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0401Class add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0401Class edit')
    return client.postData({ data: { find: { api: 'M0401ClassService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },

  importStudents: ({ commit, state }, rows) => {
    console.debug('called M0401Class import')
    return client.postData({ data: { import: { api: 'M0401ClassService.importStudents', input: rows } } })
      .then((data) => {
        const output = data.import.output
        if (output === true) {
          SysUtils.showSuccess('Import Successful!')
        } else if (rows.additionalCond) {
          alert('Import failed, please check you sql!')
        } else if (output === false) {
          SysUtils.showError('Import failed')
        }
        // commit('MAIL', data.mail.output)
      })
  },
  sendMail: ({ commit, state }, condition) => {
    console.debug('called M0401Class edit')
    return client.postData({ data: { find: { api: 'M0401ClassService.sendMail', input: condition } } })
      .then((data) => {
        SysUtils.showSuccess('Email Sent Successful!')
        commit('MAIL', data.mail.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0401Class delete')
    return client.postData({ data: { delete: { api: 'M0401ClassService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('EDIT', null)
        SysUtils.showSuccess('Record successfully deleted')
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0401Class save')
    return client.postData({ data: { save: { api: 'M0401ClassService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
        SysUtils.showSuccess('Record successfully saved')
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0401Class download')
    return client.download({ data: { download: { api: 'M0401ClassService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0401Class/M0401ClassStore.js